<script>
	import './index.scss';
	import { pkgBrief } from "../store.js";
	
	export let index;

	function removeElement(index) {
		$pkgBrief.splice(index, 1);
		$pkgBrief = $pkgBrief;
	};

	function changeImage(){
		$pkgBrief[index].content = event.target.files[0];
		$pkgBrief[index].detail = URL.createObjectURL(event.target.files[0]);
	};

</script>

<div class="field">
	<label class="label has-text-white">Image <a class="help remove-element" on:click={() => removeElement(index)}>(click to remove)</a></label>
	<div class="file has-name">
		<label class="file-label has-text-white">
			<input class="file-input" type="file" name="resume" on:change={() => changeImage()}>
			<span class="file-cta">
				<span class="file-icon">
					<i class="fas fa-upload"></i>
				</span>
				<span class="file-label">
					Choose a file
				</span>
			</span>
			<span class="file-name">
				{$pkgBrief[index].detail}
			</span> &nbsp; &nbsp;
		</label>
	</div>
</div>